import { style } from "@vanilla-extract/css";
import { stickyListHeader } from "plos/src/styles/listTables.css";

export const transfersTableElement = style([
  stickyListHeader,
  {
    zIndex: 15,
    top: 0,
    insetInlineStart: 0,
    marginTop: 0,
    width: 200,
  },
]);

export const transfersTableStat = style([
  stickyListHeader,
  {
    width: 50,
  },
]);
